/*
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is
 * regenerated.
 */

import * as coreHttp from "@azure/core-http";
import * as Models from "../models";
import * as Mappers from "../models/betaEnrollmentMappers";
import { MicrosoftConsumerSecurityClientContext } from "../microsoftConsumerSecurityClientContext";

/** Class representing a BetaEnrollment. */
export class BetaEnrollment {
  private readonly client: MicrosoftConsumerSecurityClientContext;

  /**
   * Create a BetaEnrollment.
   * @param {MicrosoftConsumerSecurityClientContext} client Reference to the service client.
   */
  constructor(client: MicrosoftConsumerSecurityClientContext) {
    this.client = client;
  }

  /**
   * Gets capacity data for each platform.
   * @summary Gets capacity data for each platform.
   * @param [options] The optional parameters
   * @returns Promise<Models.BetaEnrollmentGetBetaCapacityDataResponse>
   */
  getBetaCapacityData(options?: coreHttp.RequestOptionsBase): Promise<Models.BetaEnrollmentGetBetaCapacityDataResponse>;
  /**
   * @param callback The callback
   */
  getBetaCapacityData(callback: coreHttp.ServiceCallback<Models.BetaCapacityData>): void;
  /**
   * @param options The optional parameters
   * @param callback The callback
   */
  getBetaCapacityData(options: coreHttp.RequestOptionsBase, callback: coreHttp.ServiceCallback<Models.BetaCapacityData>): void;
  getBetaCapacityData(options?: coreHttp.RequestOptionsBase | coreHttp.ServiceCallback<Models.BetaCapacityData>, callback?: coreHttp.ServiceCallback<Models.BetaCapacityData>): Promise<Models.BetaEnrollmentGetBetaCapacityDataResponse> {
    return this.client.sendOperationRequest(
      {
        options
      },
      getBetaCapacityDataOperationSpec,
      callback) as Promise<Models.BetaEnrollmentGetBetaCapacityDataResponse>;
  }

  /**
   * Enrolls user in beta track.
   * @summary Enrolls user in beta track.
   * @param [options] The optional parameters
   * @returns Promise<coreHttp.RestResponse>
   */
  enrollBetaUser(options?: coreHttp.RequestOptionsBase): Promise<coreHttp.RestResponse>;
  /**
   * @param callback The callback
   */
  enrollBetaUser(callback: coreHttp.ServiceCallback<void>): void;
  /**
   * @param options The optional parameters
   * @param callback The callback
   */
  enrollBetaUser(options: coreHttp.RequestOptionsBase, callback: coreHttp.ServiceCallback<void>): void;
  enrollBetaUser(options?: coreHttp.RequestOptionsBase | coreHttp.ServiceCallback<void>, callback?: coreHttp.ServiceCallback<void>): Promise<coreHttp.RestResponse> {
    return this.client.sendOperationRequest(
      {
        options
      },
      enrollBetaUserOperationSpec,
      callback);
  }
}

// Operation Specifications
const serializer = new coreHttp.Serializer(Mappers);
const getBetaCapacityDataOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "GET",
  path: "api/v1/beta/enrollment",
  responses: {
    200: {
      bodyMapper: Mappers.BetaCapacityData
    },
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const enrollBetaUserOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "POST",
  path: "api/v1/beta/enrollment",
  responses: {
    204: {},
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};
